import { render, staticRenderFns } from "./ParsingPage.vue?vue&type=template&id=b72af476&scoped=true&"
import script from "./ParsingPage.vue?vue&type=script&lang=js&"
export * from "./ParsingPage.vue?vue&type=script&lang=js&"
import style0 from "./ParsingPage.vue?vue&type=style&index=0&id=b72af476&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b72af476",
  null
  
)

export default component.exports